import { render, staticRenderFns } from "./CourseForm.vue?vue&type=template&id=414923f1&scoped=true&"
import script from "./CourseForm.vue?vue&type=script&lang=js&"
export * from "./CourseForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseForm.vue?vue&type=style&index=0&id=414923f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414923f1",
  null
  
)

export default component.exports